// extracted by mini-css-extract-plugin
export default {"sparkle":"sparkle--G0wxl","sparkles-come-in-out":"sparkles-come-in-out--ZolLa","sparkles-spin":"sparkles-spin--qETUO","sparkles-area-overlay":"sparkles-area-overlay--UqrCF"};